import { useQuery } from '@tanstack/react-query';

import { getAchievements } from '~/services/AgentHub/AgentService';

import { GetAchievementsParams } from '~/types/services/agentHub';

export const achievementQueryKeys = {
  all: ['achievements'] as const,
  lists: () => [...achievementQueryKeys.all, 'list'] as const,
  list: (params: GetAchievementsParams) => [...achievementQueryKeys.lists(), params] as const,
  details: () => [...achievementQueryKeys.all, 'detail'] as const,
  detail: (id: string) => [...achievementQueryKeys.details(), id] as const,
};

export function useListAchievements(params: GetAchievementsParams) {
  return useQuery({
    placeholderData: (prev) => {
      return {
        rows: prev?.rows ?? [],
        total: prev?.total ?? 0,
      };
    },
    queryKey: achievementQueryKeys.list(params),
    queryFn: async () => {
      return await getAchievements(params);
    },
  });
}
